import React, { Component } from "react";
import { css, StyleSheet } from "aphrodite/no-important";
import utils from "libs/utils";

import CircleNumber from "../../components/icons/circleNumber";
import VideoPlain from "./videoPlain";

class coloumnInfoBox extends Component {
  constructor(props) {
    super(props);
  }

  checkForMaxWidth() {
    if (this.props.maxWidth) {
      return {
        maxWidth: `${this.props.maxWidth}px`,
        margin: "0 auto"
      };
    }
  }

  checkForSpacing(i, length) {
    if (
      this.props.spacer &&
      i < length - 1 &&
      utils.isClient() &&
      window.innerWidth > 599
    ) {
      return `${css(styles.spacer)}`;
    }
  }

  checkForVideo(youtubeVideoId, icon, iconSize) {
    if (youtubeVideoId) {
      return (
        <VideoPlain
          youtubeVideoId={youtubeVideoId}
          previewImage={icon}
          maxWidth={iconSize}
        />
      );
    } else {
      return (
        <img
          className={`${css(styles.icon)}`}
          width={iconSize ? iconSize : "25"}
          src={icon}
        />
      );
    }
  }

  createBlocks(info) {
    const padding = this.props.padding ? this.props.padding : "5";

    return info.map((item, i) => {
      return (
        <div
          key={i}
          className={`col-md-${12 / info.length} ${this.checkForSpacing(
            i,
            info.length
          )} `}
        >
          {item.number ? <CircleNumber number={i + 1} /> : ""}

          {item.icon
            ? this.checkForVideo(item.youtubeVideoId, item.icon, item.iconSize)
            : ""}
          <h3
            className={`${css(styles.heading)}`}
            style={this.props.headerStyle}
          >
            {item.heading}
          </h3>
          <p
            className={` pl-${padding} pr-${padding} ${css(styles.p)}`}
            style={this.props.paragraphStyle}
          >
            {item.paragraph}
          </p>
          {item.linkUrl ? (
            <a
              className="tinyLink"
              style={{ marginTop: "10px", display: "block" }}
              href={item.linkUrl}
              target={item.target ? item.target : ""}
            >
              {item.linkText}
            </a>
          ) : (
            ""
          )}
        </div>
      );
    });
  }

  render() {
    return (
      <div className="text-center">
        <div className={`row benefits`} style={this.checkForMaxWidth()}>
          {this.createBlocks(this.props.data)}
        </div>
      </div>
    );
  }
}

export default coloumnInfoBox;

const styles = StyleSheet.create({
  p: {
    marginBottom: "0px"
  },
  icon: {
    marginBottom: "15px"
  },
  heading: {
    color: "#1499D4",
    fontSize: "18px!important",
    marginBottom: "8px!important",
    marginTop: "5px"
  },
  spacer: {
    borderRight: "1px dashed #ccc"
  }
});



// WEBPACK FOOTER //
// ./src/sections/layouts/columnInfoBox.js